"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROI_CAMPAIGN_PURPOSES = exports.defaultMarginOfBarChart = exports.DEFAULT_BREAKDOWN_QUERY_PARAMS = void 0;

var _ui = require("@alycecom/ui");

var _roi = require("./roi.types");

var DEFAULT_BREAKDOWN_QUERY_PARAMS = {
  limit: _ui.RowLimit.Limit10,
  offset: 0
};
exports.DEFAULT_BREAKDOWN_QUERY_PARAMS = DEFAULT_BREAKDOWN_QUERY_PARAMS;
var defaultMarginOfBarChart = {
  top: 0,
  right: 60,
  bottom: 0,
  left: 20
}; // be aware that the order matters in this case

exports.defaultMarginOfBarChart = defaultMarginOfBarChart;
var ROI_CAMPAIGN_PURPOSES = [{
  label: 'Event Invitation',
  value: _roi.CampaignPurposes.EventInvitation
}, {
  label: 'Event Follow-up',
  value: _roi.CampaignPurposes.EventFollowUp
}, {
  label: 'Lead Gen/Door-Opener',
  value: _roi.CampaignPurposes.DoorOpener
}, {
  label: 'Deal Acceleration',
  value: _roi.CampaignPurposes.DealAcceleration
}, {
  label: 'Lead Re-engagement',
  value: _roi.CampaignPurposes.LeadReEngagement
}, {
  label: 'New Customer Welcome/Milestone',
  value: _roi.CampaignPurposes.NewCustomer
}, {
  label: 'Celebration',
  value: _roi.CampaignPurposes.Celebration
}, {
  label: 'Customer Loyalty',
  value: _roi.CampaignPurposes.CustomerLoyalty
}, {
  label: 'Renewal/Retention',
  value: _roi.CampaignPurposes.Renewal
}, {
  label: 'Partnership/Referral',
  value: _roi.CampaignPurposes.Partnership
}, {
  label: 'HR',
  value: _roi.CampaignPurposes.Hr
}, {
  label: 'Thank you',
  value: _roi.CampaignPurposes.ThankYou
}, {
  label: 'Please Accept Our Apology',
  value: _roi.CampaignPurposes.Apology
}, {
  label: 'Other',
  value: _roi.CampaignPurposes.Other
}];
exports.ROI_CAMPAIGN_PURPOSES = ROI_CAMPAIGN_PURPOSES;